import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { Sticker } from '@/components/ui';
import { PasswordLoginForm, CodeRequestForm } from '@/features/auth/request-form';

export function LoginPage() {
  const [useCode, setUseCode] = useState(false);

  return (
    <div className="flex flex-col gap-6">
      <div>
        <Sticker flavor="grape" rotate={-3}>
          welcome back
        </Sticker>
        <h1 className="mt-4 text-3xl font-semibold">Log in</h1>
        <p className="mt-2 text-sm text-ink-soft">
          {useCode ? 'We’ll email you a one-time code.' : 'Email and password.'}
        </p>
      </div>

      {useCode ? <CodeRequestForm intent="login" /> : <PasswordLoginForm />}

      <div className="flex flex-col gap-1 text-sm text-ink-soft">
        {!useCode && (
          <Link to="/forgot" className="font-semibold underline">
            Forgot your password?
          </Link>
        )}
        <button
          type="button"
          onClick={() => setUseCode((v) => !v)}
          className="self-start font-semibold underline"
        >
          {useCode ? 'Use email and password' : 'Email me a code instead'}
        </button>
      </div>

      <p className="text-sm text-ink-soft">
        New to Nearmirer?{' '}
        <Link to="/signup" className="font-semibold underline">
          Make an account
        </Link>
      </p>
    </div>
  );
}
